import React from 'react';
import Posting from './Posting';

export default function Postings(props) {

    const x = props.x;
	const [postingSource, setPostingSource] = React.useState([]);       // Enthält die Posting-Daten vom Server. Diese werden dann in der Funktion makePostings aufbereitet. 
	const [selectedPostingNo, setSelectedPostingNo] = React.useState(0);
	const [lastPostingNoRead, setLastPostingNoRead] = React.useState(0);
	const [focusedThread, setFocusedThread] = React.useState(false);       // true, wenn gerade ein einzelner Thread/Tag (statt der aktuellen Ansicht) angezeigt wird
	// x.was.foren wird einmalig beim Start geladen (WebappSystem.js) - hier nur direkt lesen, kein eigener Request pro Forum-Ansicht.
	const maxLines = (x.was.foren[props.moduleId] && x.was.foren[props.moduleId].maxlines) || 10;
	const scrollToView = React.useRef(false);
	const forceScrollBottom = React.useRef(false); // true = naechstes Laden soll im Chat-Modus in jedem Fall ans Ende springen (User-Aktion "Zum neuesten Beitrag")
	const wasAtBottom = React.useRef(true); // true = Container war vor dem Nachladen bereits (nahezu) am Ende gescrollt
	const onLoaded = x.wau.getProperty(props.onLoaded, () => {});
	const threadMode = x.wau.getProperty(props.threadMode, false);
		
	var selectDate = null           // Ein gesamter Tag soll gelesen werden.
	var selectThread = 0			// Ein gesamter Thread soll gelesen werden.    

	React.useEffect(() => {
		if (selectedPostingNo > 0 && scrollToView.current === true) {
			scrollToView.current = false;

			// Die Postings-Liste ist selbst der scrollbare Container (position:absolute) und zugleich
			// der offsetParent der Postings, da sie unpositioniert sind. Manuelles Scrollen dieses einen
			// Containers statt scrollIntoView(), da Letzteres bei mehreren verschachtelten scrollbaren
			// Vorfahren (z.B. .module-content) im falschen Container scrollen kann. Kein "smooth", da
			// mehrfach wiederholtes animiertes Scrollen (Layout aendert sich noch durch nachladende
			// Bilder) sich gegenseitig unterbricht und an der falschen Position stehen bleibt.
			function scrollToPosting() {
				const postingId = document.getElementById('posting-' + props.id + '-' + selectedPostingNo);
				const container = document.getElementById(props.id + '-postings');
				if (postingId !== null && container !== null) {
					const targetTop = postingId.offsetTop - (container.clientHeight / 2) + (postingId.clientHeight / 2);
					container.scrollTop = Math.max(0, targetTop);
				}
			}

			// Bei Tagen/Threads mit vielen Beitraegen (z.B. 200+) verschieben nachladende
			// Bilder/Avatare die Layout-Hoehe teils ueber deutlich laenger als 300ms hinweg -
			// eine einzelne verzoegerte Korrektur reicht dann nicht zuverlaessig aus. Stattdessen
			// wird die Position ueber ein paar Sekunden hinweg in jedem Frame erneut korrigiert,
			// analog zum "ans Ende springen" im Chat-Modus.
			let active = true;
			const deadline = Date.now() + 3000;
			function correctScrollPosition() {
				if (!active) return;
				scrollToPosting();
				if (Date.now() < deadline) {
					requestAnimationFrame(correctScrollPosition);
				}
			}
			requestAnimationFrame(correctScrollPosition);
			return () => { active = false; };
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedPostingNo]);

	React.useEffect(() => {
		const shouldFollowBottom = forceScrollBottom.current || wasAtBottom.current;
		forceScrollBottom.current = false;
		if (props.chatMode && selectedPostingNo === 0 && shouldFollowBottom) {
			// Ans Ende springen, wenn entweder explizit angefordert ("Zum neuesten Beitrag")
			// oder man ohnehin schon (nahezu) dort war - sonst wuerde jeder eingehende Beitrag
			// eine manuell nach oben gescrollte Position (z.B. beim Lesen aelterer Nachrichten)
			// unerwuenscht ueberschreiben.
			const scrollContainer = document.getElementById(props.id + '-postings');
			if (scrollContainer !== null) {
				// Bilder/Smilies/Avatare laden asynchron nach und vergroessern dabei
				// nachtraeglich die Hoehe - eine einmalige Korrektur reicht daher nicht immer.
				// Statt stur ueber eine feste Zeitspanne zu pinnen (was den Nutzer am eigenen
				// Scrollen hindern wuerde), wird nur so lange korrigiert, wie sich die Hoehe des
				// Containers tatsaechlich noch aendert - sobald sie sich ein paar Frames lang
				// nicht mehr veraendert hat, wird sofort aufgehoert. Ein Scroll-Versuch durch den
				// Nutzer selbst bricht die Korrektur ausserdem sofort ab.
				let active = true;
				let lastHeight = -1;
				let stableFrames = 0;
				const hardDeadline = Date.now() + 8000;
				function pinToBottom() {
					if (!active) return;
					const currentHeight = scrollContainer.scrollHeight;
					if (currentHeight === lastHeight) {
						stableFrames++;
					}
					else {
						stableFrames = 0;
						lastHeight = currentHeight;
					}
					scrollContainer.scrollTop = currentHeight;
					if (stableFrames < 15 && Date.now() < hardDeadline) {
						requestAnimationFrame(pinToBottom);
					}
				}
				requestAnimationFrame(pinToBottom);
				function cancelOnUserScroll() {
					active = false;
				}
				scrollContainer.addEventListener('wheel', cancelOnUserScroll, { passive: true });
				scrollContainer.addEventListener('touchstart', cancelOnUserScroll, { passive: true });

				// Diagnose: einige Sekunden spaeter tatsaechlich pruefen, ob wir wirklich am Ende
				// angekommen sind. Falls nicht (und der Nutzer nicht selbst weggescrollt hat),
				// sichtbaren Hinweis mit den genauen Werten ausgeben - damit sich der seltene,
				// nicht reproduzierbare "landet nicht ganz unten"-Fall eingrenzen laesst.
				const diagnosisTimer = setTimeout(() => {
					const distanceFromBottom = scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight;
					if (active && distanceFromBottom > 40) {
						const message = `Diagnose: Chat-Ansicht nicht ganz unten (Abstand ${Math.round(distanceFromBottom)}px, scrollHeight=${scrollContainer.scrollHeight}, clientHeight=${scrollContainer.clientHeight}).`;
						console.error(message);
						x.wah.addHint(message, false);
					}
				}, 4000);

				return () => {
					active = false;
					clearTimeout(diagnosisTimer);
					scrollContainer.removeEventListener('wheel', cancelOnUserScroll);
					scrollContainer.removeEventListener('touchstart', cancelOnUserScroll);
				};
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.chatMode, props.id, postingSource, selectedPostingNo]);

	function scrollToLatest() {
		forceScrollBottom.current = true;
		getPostings();
	}

	props.onRendered({
		"load": getPostings,
		"scrollToLatest": scrollToLatest,
		"makePostings": makePostings,
		"setSelectDate": setSelectDate,
		"setSelectThread": setSelectThread,
		"updateLastPostingNoRead": setLastPostingNoRead,
	})

	function setSelectDate(value) {
		selectDate = value;
	}

	function setSelectThread(value) {
		selectThread = value;
	}

	function getPostings(selectedPostingNo = 0) {
		if (props.chatMode) {
			// Muss vor dem Nachladen gemessen werden, da sich scrollHeight danach
			// bereits durch die neuen Beitraege veraendert hat.
			const scrollContainer = document.getElementById(props.id + '-postings');
			if (scrollContainer !== null) {
				const distanceFromBottom = scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight;
				wasAtBottom.current = distanceFromBottom < 40;
			}
		}
		setSelectedPostingNo(selectedPostingNo);
		if (selectedPostingNo > 0) {
			scrollToView.current = true;
		}
		else {
			scrollToView.current = false;
		}
		const thread = (selectThread > 0) ? '&threadno=' + selectThread : '';
		const day = (selectDate !== null) ? '&date=' + selectDate : '';
		setFocusedThread(thread !== '' || day !== '');
		let url = 'Backend/webapp.php?module=Posting&task=Postings&forumId=' + props.forumId;
		url += '&topicid=' + x.wam[props.moduleId].getCurrentTopicId() + " " + thread + day;
		// url += '&topicid=' + x.waf.getKey("form-current-topic", props.ModuleId + "-select-topic-form") + " " + thread + day;
		// console.log('Reload: ' + props.moduleId);
		x.was.axGet(url, handleGetPostings);
	}

	function backToCurrentPostings() {
		setSelectThread(0);
		setSelectDate(null);
		getPostings();
	}

	function handleGetPostings(result) {
		setSelectDate(null);
		setSelectThread(0);
		if (result.data['returncode'] === 1) {
			setPostingSource(result.data['content']['postings']);
			setLastPostingNoRead(result.data['content']['last-posting-no-read']);
			x.was.postingsUnread[props.moduleId] = result.data['content']['posting-count'] - result.data['content']['last-posting-read'];
			x.was.updatePostingsUnread();
			onLoaded({
						"postingCount" : result.data['content']['posting-count'],
						"postingDisplayCount" : result.data['content']['postings'].length,
						"last-posting-no-read" : result.data['content']['last-posting-no-read']
					});
		}
		else {
			x.wah.addHint('Kann Posting-Tabelle nicht lesen!');
		}
	}

	function setTopic(id, name) {
		x.wad[props.moduleId + '-select-topic-dialog'].setValue(id, name);
	}



	// Kehrt im Chat-Modus die Reihenfolge der Threads um (neuester Thread unten),
	// ohne die chronologische Reihenfolge innerhalb eines Threads (Ausgangsposting
	// vor seinen Antworten) zu veraendern. Ein einfaches column-reverse per CSS
	// wuerde jeden einzelnen Listeneintrag (auch Antworten) isoliert umdrehen.
	function groupByThreadReversed(source) {
		const groups = [];
		let currentGroup = null;
		source.forEach((item) => {
			if (currentGroup === null || item.threadno !== currentGroup.threadno) {
				currentGroup = { threadno: item.threadno, items: [] };
				groups.push(currentGroup);
			}
			currentGroup.items.push(item);
		});
		return groups.reverse().flatMap((group) => group.items);
	}

	function makePostings(source = postingSource) {

		if (props.chatMode) source = groupByThreadReversed(source);

		let postingTags = [];
		let postingCount = 0;
		let content = '';
		let title = '';
		const paddingLeft = (props.hideAvatar) ? 4 : 56;
		// console.time(props.id);
		if (source.length > 0) {
			source.forEach(
				function (item, index) {
					postingCount++;
					if (item.visible > -1) {
						if (item.postingno === item.threadno) {
							postingTags.push(
								<Posting
									key={postingCount}
									id={props.id + '-' + item.postingno}
									threadMode={threadMode}
									x={x}  
									moduleId={props.moduleId}
									mode="thread"
									posting={item}
									getPostings={getPostings}
									selectedPostingNo={selectedPostingNo}
									hideContent={props.hideContent}
									hideDiscussion={props.hideDiscussion}
									hideOT={props.hideOT}
									hideAvatar={props.hideAvatar}
									hideDate={props.hideDate}
									showDialogAnswer={props.showDialogAnswer}
									content={content}
									title={title}
									paddingLeft={paddingLeft}
									setTopic={setTopic}
									postingQuote={props.postingQuote}
									copyToClipboard={props.copyToClipboard}
									lastPostingRead={lastPostingNoRead}
									typingMemberName={props.typingMemberName}
									maxLines={maxLines}
								/>
							);
						}
						else {
							postingTags.push(
								<Posting
									key={postingCount}
									id={props.id + '-' + item.postingno}
									threadMode={threadMode}
									x={x}  
									moduleId={props.moduleId}
									thread={false}
									mode="answer"
									posting={item}
									getPostings={getPostings}
									selectedPostingNo={selectedPostingNo}
									hideContent={props.hideContent}
									hideDiscussion={props.hideDiscussion}
									hideOT={props.hideOT}
									hideAvatar={props.hideAvatar}
									hideDate={props.hideDate}
									showDialogAnswer={props.showDialogAnswer}
									content={content}
									title={title}
									paddingLeft={paddingLeft}
									setTopic={setTopic}
									postingQuote={props.postingQuote}
									copyToClipboard={props.copyToClipboard}
									lastPostingRead={lastPostingNoRead}
									typingMemberName={props.typingMemberName}
									maxLines={maxLines}
								/>
							);
						}
					}
				}
			)
		}
		if (postingCount > 0 && !props.chatMode) {
			postingTags.push(
				<div key="posting-count-footer" className="posting-count-footer">
					{postingCount} {postingCount === 1 ? 'Beitrag angezeigt' : 'Beiträge angezeigt'}
				</div>
			);
		}

		return postingTags;
	}
	return (<div id={props.id + '-div'} className={`
											posting-parent
											${props.classes}
											${(props.memberColored === 1) ? "member-colored" : ""}
											${(props.fontBold === 1) ? "posting-content-font-bold" : "posting-content-font-normal"}
										`}>
		{focusedThread &&
			<div className="postings-focused-thread-bar" onClick={backToCurrentPostings}>
				<i className="bi bi-arrow-left"></i> Zurück zur aktuellen Ansicht
			</div>
		}
		<div id={props.id + '-postings'} className={`forum ${(props.forumScroll === 1) ? 'forum-postings-scroll' : 'forum-postings'} ${(props.hideImages === 1) ? 'hide-images' : ''} ${(props.chatMode) ? "forum-postings-chat-mode" : ""}`}>
			{makePostings()}
		</div>
	</div>
	)
};
